import { ConnectedRouter } from 'connected-react-router';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import App from './app';
import { ErrorBoundary } from './components';
import registerServiceWorker from './register-service-worker';
import configureStore from './store/configure-store';
import { history } from './util/history';

import './assets/css/global.css';
import './assets/scss/argon-design-system-react.scss?v1.1.0';

// Create browser history to use in the Redux store
// Get the application-wide store instance, prepopulating with state from the server where available.
export const { store, persistor } = configureStore(history);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
                <ErrorBoundary>
                    <App />
                </ErrorBoundary>
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

registerServiceWorker();
